import React from "react";
import PropTypes from "prop-types";

import { Checkbox, Icon, Popup } from "semantic-ui-react";

export function ConfirmationCheckbox({ name, info, children, text, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "top",
        marginBottom: "0.5em",
      }}
    >
      <Checkbox
        name={name}
        onChange={onChange}
        style={{ marginTop: "0.1em" }}
      />
      <div style={{ color: "white", marginLeft: "0.5em" }}>
        {children || text}
      </div>
      {info && (
        <Popup
          trigger={
            <Icon
              style={{ marginLeft: "0.5em" }}
              name="question circle"
              data-test="info-popup"
            />
          }
          on="hover"
          position="bottom center"
          content={info}
        />
      )}
    </div>
  );
}

ConfirmationCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
  info: PropTypes.node,
  onChange: PropTypes.func,
};

ConfirmationCheckbox.defaultProps = {
  info: undefined,
  text: undefined,
  children: undefined,
  onChange: () => {},
};

export default ConfirmationCheckbox;
